require('dotenv').config();

export const API_SERVER = process.env.REACT_APP_API_SERVER || 'api-server';
export const ENABLE_MOCK_DATA = process.env.REACT_APP_ENABLE_MOCK_DATA === 'true' || false;
